import { useMemo } from "react";
import { useSnackbarLazyQuery } from "../../hooks";
import { Building } from "../models";
import { QUERIES } from "../queries";

export function useBuildings() {
  const [
    fetchLiteBuildingsList,
    {
      data: liteBuildingsListData,
      loading: liteBuildingsListLoading,
      error: liteBuildingsListError,
      refetch: refetchLiteBuildingsList,
    },
  ] = useSnackbarLazyQuery(QUERIES.BUILDINGS("light"));

  const liteBuildingsList: Building[] = useMemo(() => {
    if (liteBuildingsListData) {
      return liteBuildingsListData.buildings;
    }

    return [];
  }, [liteBuildingsListData]);

  return {
    fetchLiteBuildingsList,
    refetchLiteBuildingsList,
    liteBuildingsList,
    liteBuildingsListError,
    liteBuildingsListLoading,
  };
}
